module.exports = __webpack_public_path__ + "img/collection-engagementRingsClassic@2x.c92d5d8.jpg";